import React, { useState, useRef } from 'react';
import { useTranslation } from 'react-i18next';
import styles from './WatchlistPanel.module.css';

function fmtDate(iso) {
  if (!iso) return '';
  try {
    return new Date(iso).toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
  } catch { return ''; }
}

function fmtTime(date) {
  return date.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', second: '2-digit', hour12: true });
}

export default function WatchlistPanel({ items, onScreen, onRemove, onClear, onRefresh }) {
  const { t } = useTranslation();
  const [confirmClear, setConfirmClear] = useState(false);
  const loadedAt = useRef(new Date());

  const hasItems = items && items.length > 0;

  return (
    <div className={styles.wrap}>
      <div className={styles.header}>
        <div className={styles.headerLeft}>
          {hasItems && <span className={styles.label}>{t('watchlist.label')}</span>}
          {hasItems && <span className={styles.count}>{items.length}</span>}
        </div>
        <div className={styles.actions}>
          <div className={styles.btnRow}>
            {hasItems && !confirmClear && (
              <button className={styles.actionBtn} onClick={() => setConfirmClear(true)}>{t('watchlist.clear_all')}</button>
            )}
            {hasItems && confirmClear && (
              <>
                <button className={`${styles.actionBtn} ${styles.actionBtnDanger}`} onClick={() => { onClear(); setConfirmClear(false); }}>{t('watchlist.confirm')}</button>
                <button className={styles.actionBtn} onClick={() => setConfirmClear(false)}>{t('watchlist.cancel')}</button>
              </>
            )}
            <button className={styles.actionBtn} onClick={onRefresh} title={t('watchlist.refresh_title')}>
              {t('watchlist.refresh')}
            </button>
          </div>
          <span className={styles.refreshedAt}>{t('watchlist.as_of', { time: fmtTime(loadedAt.current) })}</span>
        </div>
      </div>

      {hasItems && (
        <div className={styles.grid}>
          {items.map(item => (
            <div
              key={item.ticker}
              className={`${styles.card} ${styles['card_' + item.verdict]}`}
              onClick={() => onScreen(item.ticker)}
              role="button"
              tabIndex={0}
              onKeyDown={e => e.key === 'Enter' && onScreen(item.ticker)}
              title={t('watchlist.screen_title', { ticker: item.ticker })}
            >
              <button
                className={styles.removeBtn}
                onClick={e => { e.stopPropagation(); onRemove(item.ticker); }}
                aria-label={t('watchlist.remove_aria', { ticker: item.ticker })}
              >✕</button>

              <div className={styles.ticker}>{item.ticker}</div>
              <div className={styles.company}>{item.companyName || '—'}</div>

              <div className={styles.footer}>
                <span className={`${styles.verdict} ${styles['verdict_' + item.verdict]}`}>
                  {t(`watchlist.verdict.${item.verdict}`) || item.verdict || '—'}
                </span>
                {item.price
                  ? <span className={styles.price}>${item.price.toFixed(2)}</span>
                  : <span className={styles.date}>{fmtDate(item.updatedAt || item.savedAt)}</span>
                }
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}
